<template>
  <jc-dialog ref="dialog" :show.sync="show"
             btn-confirm-text='<i class="fad fa-save"></i> Cập nhật'
             title="Cập nhật cấu hình kho"
             type="orange"
             @onConfirm="$refs.form.submit()"
  >
    <c-form ref="form" @submit="submit()">
      <c-input v-model="model.shopName" disabled="" label="Shop" validate-rules="required"/>
      <c-input v-model="model.oldStationName" disabled label="Kho fulfillment cũ" validate-rules="required"/>
      <c-select2 v-model="model.new_station_id"
                 label="Kho fulfillment mới"
                 placeholder="Nhập tên kho"
                 uri="cms/api/v1.0/select2/all-station"
                 validate-rules="required"/>

      <c-input v-model.trim="model.tel"
               label="Số điện thoại kho"
      />

      <c-input v-model="model.first_address" label="Địa chỉ kho người dùng cung cấp"/>

    </c-form>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "warehouse-update",
  mixins: [dialogMixins],
  data() {
    return {
      model: {
        shopName: null,
        shop_order: null,
        oldStationName: null,
        old_station_id: null,
        new_station_id: null,
        first_address: null
      },
    }
  },
  methods: {
    open(id) {
      this.model = {
        shopName: null,
        shop_order: null,
        oldStationName: null,
        old_station_id: null,
        new_station_id: null,
        first_address: null
      };
      if (id) {
        this.getData(id);
      } else {
        this.$warning('Chưa chọn cấu hình kho muốn thay đổi')
      }
    },
    submit: function (event) {
      this.$showLoader();

      let data = {
        "first_address": this.model.first_address,
        "old_station_id": this.model.old_station_id,
        "new_station_id": this.model.new_station_id,
        "tel": this.model.tel
      }
      this.$http
          .put("/admin-service/v1.0/station/warehouse-shop?shop_order=" + this.model.shop_order, data)
          .then(
              res => {
                this.close();
                this.$success();
                this.$stopLoader();

                this.$emit("success", res);
              }
          )
          .catch(err => {
            this.errorNotify(err)
                .then(errorRes => this.$cmsBadRequest(errorRes))
            ;
            this.$stopLoader();
            this.$emit("error", err);
          })
      ;
    },
    getData(id) {
      let vue = this;
      if (id) {
        vue.$http.get("/cms/api/v1.0/shop-warehouse/get/" + id).then(res => {
          let data = res.data;
          vue.model.shop_order = data.shopOrder;
          vue.model.shopName = data.shopName;
          vue.model.old_station_id = data.stationId;
          vue.model.oldStationName = data.stationName;

          this.show = true;
        }).catch(err => {
          this.errorNotify(err)
              .then(errorRes => this.$cmsBadRequest(errorRes))
          ;
          this.close();
        })
      }
    },
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>